import React from "react";
import Pagination from 'react-bootstrap/Pagination';

const buildVisiblePages = (currentPage, totalPages, maxVisible = 5) => {
    if (totalPages <= maxVisible) {
        return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const halfWindow = Math.floor(maxVisible / 2);
    let start = Math.max(1, currentPage - halfWindow);
    let end = start + maxVisible - 1;

    if (end > totalPages) {
        end = totalPages;
        start = Math.max(1, end - maxVisible + 1);
    }

    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
};

const PortalPagination = ({
    currentPage,
    totalPages,
    onPageChange,
    maxVisible = 5
}) => {
    if (totalPages <= 1) {
        return (
            <div className="portal-pagination-nav">
                <span className="portal-pagination-meta">Pagina 1 de 1</span>
            </div>
        );
    }

    const visiblePages = buildVisiblePages(currentPage, totalPages, maxVisible);
    const firstVisiblePage = visiblePages[0];
    const lastVisiblePage = visiblePages[visiblePages.length - 1];

    return (
        <div className="portal-pagination-nav">
            <span className="portal-pagination-meta">{`Pagina ${currentPage} de ${totalPages}`}</span>

            <Pagination className="mb-0">
                <Pagination.Prev disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)} />

                {firstVisiblePage > 1 ? (
                    <>
                        <Pagination.Item onClick={() => onPageChange(1)}>1</Pagination.Item>
                        {firstVisiblePage > 2 ? <Pagination.Ellipsis disabled /> : null}
                    </>
                ) : null}

                {visiblePages.map((pageNumber) => (
                    <Pagination.Item
                        active={pageNumber === currentPage}
                        key={pageNumber}
                        onClick={() => onPageChange(pageNumber)}
                    >
                        {pageNumber}
                    </Pagination.Item>
                ))}

                {lastVisiblePage < totalPages ? (
                    <>
                        {lastVisiblePage < totalPages - 1 ? <Pagination.Ellipsis disabled /> : null}
                        <Pagination.Item onClick={() => onPageChange(totalPages)}>{totalPages}</Pagination.Item>
                    </>
                ) : null}

                <Pagination.Next disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)} />
            </Pagination>
        </div>
    );
};

export default PortalPagination;
